<!-- eslint-disable vue/no-mutating-props, vue/no-multiple-template-root, no-undef -->
<template>
  <div class="profile-settings">
    <!-- profile-edit-container-->
    <div class="profile-edit-container">
      <div class="profile-edit-header fl-wrap">
        <div>
          <div style="display: flex; justify-content: space-between; align-items: center">
            <div>
              <h4>My Account</h4>
              <p>Account Create Date: {{ formatCreatedAt }}</p>
              <p>Breeder: {{ isBreeder }}</p>
              <p>Service Provider: {{ isServiceProvider }}</p>
            </div>

            <div
              class="edit-profile-photo fl-wrap"
              style="width: 20%"
            >
              <img
                id="avatarImageShow"
                :src="getProfileImage(userProfile?.photoURL)"
                class="respimg"
                alt=""
              >
              <div class="change-photo-btn">
                <div
                  class="photoUpload"
                  :class="{ 'is-loading': photoUploadLoading }"
                >
                  <span>
                    <i class="fas fa-regular fa-upload" />
                    {{ photoUploadLoading ? 'Yükleniyor...' : 'Upload Photo' }}
                  </span>
                  <input
                    type="file"
                    class="upload"
                    accept="image/*"
                    :disabled="photoUploadLoading"
                    @change="$emit('photo-upload', $event)"
                  >
                </div>
              </div>
              <p
                v-if="photoUploadError"
                class="upload-error"
              >
                {{ photoUploadError }}
              </p>
            </div>
          </div>
          <div class="custom-form">
            <label>Account Type </label>

            <div style="display: flex; float: left">
              <div class="radio form-check add-list-media-header">
                <label
                  class="inline"
                  for="accountType1"
                >
                  <input
                    id="accountType1"
                    v-model="accountTypeModel"
                    type="radio"
                    name="company"
                    value="Personal"
                  >
                  <span>Personal </span>
                </label>
              </div>

              <div class="radio form-check add-list-media-header">
                <label
                  class="inline"
                  for="accountType2"
                >
                  <input
                    id="accountType2"
                    v-model="accountTypeModel"
                    type="radio"
                    name="company"
                    value="Company"
                  >
                  <span>Company </span>
                </label>
              </div>
            </div>
          </div>

          <div
            v-if="accountTypeModel === 'Company' && userProfile?.account?.service_account"
            class="custom-form"
          >
            <label>Company Name <i class="fa fa-briefcase" /></label>
            <input
              v-model="userProfile.account.service_account.company_name"
              type="text"
              :placeholder="userProfile.account.service_account.company_name"
            >
          </div>
        </div>
      </div>
      <div class="custom-form">
        <label>
          Email Address <small>(cannot be change)</small>
          <i class="fas fa-regular fa-envelope" />
        </label>
        <input
          type="text"
          :placeholder="userProfile?.email"
          disabled
        >

        <label>Your Name <i class="fas fa-regular fa-user" /></label>
        <input
          v-model="userProfile.displayName"
          type="text"
        >

        <label>Phone<i class="fas fa-regular fa-phone" /> </label>
        <input
          v-model="phoneNumberModel"
          type="text"
        >

        <label>
          Postcode <small> (Require for listing)</small>
          <i class="fas fa-regular fa-map-marker" />
        </label>
        <input
          v-model="postalCodeModel"
          type="text"
        >

        <button
          class="btn big-btn color-bg flat-btn mb-2"
          :disabled="postalCheckLoading"
          @click="$emit('check-postal-code')"
        >
          {{ postalCheckLoading ? 'Checking...' : 'Check Postcode' }}
        </button>
        <!-- Posta kodu kaydetme butonunu daha dikkat çekici hale getirme -->
        <button
          v-if="isValidPostalCode && postalCodeValidatedButNotSaved"
          class="btn big-btn color-bg flat-btn mb-2 save-postal-btn"
          :disabled="postalCheckLoading"
          data-tooltip="You need to save this postal code to use it"
          @click="$emit('save-postal-code')"
        >
          <i class="fas fa-save" />
          {{ postalCheckLoading ? 'Saving...' : 'Save Postal Code' }}
        </button>

        <p
          v-if="postalCodeSaved"
          class="postal-success"
        >
          <i class="fas fa-check-circle" /> Postal code saved successfully
        </p>
        <p
          v-if="isValidPostalCode"
          style="color: green"
        >
          Postal code is valid
        </p>
        <p
          v-else-if="postalError"
          style="color: red"
        >
          {{ postalError }}
        </p>

        <div v-if="suggestedAddress">
          <p>>> {{ suggestedAddress }}</p>
          <input
            v-if="isValidPostalCode"
            v-model="updateAddressModel"
            type="checkbox"
            @change="$emit('fill-address')"
          >
          use this address
        </div>
        <label> Address <i class="fas fa-regular fa-map-marker" /> </label>
        <input
          v-model="addressModel"
          type="text"
        >

        <label> About</label>
        <textarea
          v-model="aboutMeModel"
          cols="40"
          rows="3"
        />
      </div>
    </div>
    <div class="profile-edit-container">
      <div class="custom-form mt-2">
        <button
          class="btn big-btn color-bg flat-btn"
          @click="$emit('save')"
        >
          {{ saveLoading ? 'Saving...' : 'Save Changes' }}
        </button>
        <div v-if="saveError">
          {{ saveError }}
        </div>
      </div>
    </div>
    <!-- profile-edit-container end-->
  </div>
</template>

<script setup>
import { defineProps, defineEmits, computed } from 'vue';


const props = defineProps({
  userProfile: {
    type: Object,
    required: true
  },
  formatCreatedAt: {
    type: String,
    required: true
  },
  isBreeder: {
    type: Boolean,
    required: true
  },
  isServiceProvider: {
    type: Boolean,
    required: true
  },
  photoUploadLoading: {
    type: Boolean,
    default: false
  },
  photoUploadError: {
    type: String,
    default: null
  },
  postalCheckLoading: {
    type: Boolean,
    default: false
  },
  isValidPostalCode: {
    type: Boolean,
    default: false
  },
  postalCodeValidatedButNotSaved: {
    type: Boolean,
    default: false
  },
  postalCodeSaved: {
    type: Boolean,
    default: false
  },
  postalError: {
    type: String,
    default: null
  },
  suggestedAddress: {
    type: String,
    default: null
  },
  saveLoading: {
    type: Boolean,
    default: false
  },
  saveError: {
    type: String,
    default: null
  },
  accountType: {
    type: String,
    required: true
  },
  phoneNumber: {
    type: String,
    required: true
  },
  postalCode: {
    type: String,
    required: true
  },
  updateAddress: {
    type: Boolean,
    required: true
  },
  address: {
    type: String,
    required: true
  },
  aboutMe: {
    type: String,
    required: true
  }
});

const emit = defineEmits([
  'update:accountType',
  'update:phoneNumber',
  'update:postalCode',
  'update:updateAddress',
  'update:address',
  'update:aboutMe',
  'photo-upload',
  'check-postal-code',
  'save-postal-code',
  'fill-address',
  'save'
]);

// v-model wrappers
const accountTypeModel = computed({
  get: () => props.accountType,
  set: (val) => emit('update:accountType', val)
});
const phoneNumberModel = computed({
  get: () => props.phoneNumber,
  set: (val) => emit('update:phoneNumber', val)
});
const postalCodeModel = computed({
  get: () => props.postalCode,
  set: (val) => emit('update:postalCode', val)
});
const updateAddressModel = computed({
  get: () => props.updateAddress,
  set: (val) => emit('update:updateAddress', val)
});
const addressModel = computed({
  get: () => props.address,
  set: (val) => emit('update:address', val)
});
const aboutMeModel = computed({
  get: () => props.aboutMe,
  set: (val) => emit('update:aboutMe', val)
});

const getProfileImage = (photoURL) => {
  if (photoURL && photoURL.includes('=s96-c')) {
    return photoURL.replace('=s96-c', '=s400-c');
  }
  return photoURL || 'https://firebasestorage.googleapis.com/v0/b/petqueen-v3.firebasestorage.app/o/public%2Fassets%2Fdefault-avatar.png?alt=media';
};
</script>


